import { useDispatch, useSelector } from 'react-redux'
import { useRef } from 'react'
import { useMemo } from 'react'

import InputBox from '../../../common/interactive/InputBox'
import { caseQuickUpdate } from '../../../../lib/fetchApi'
import { notificationActions } from '../../../../store/notifications'
import { stateOptions } from "../../../../lib/systemData"
import { caseActions } from '../../../../store/case'
import CustomSelect from '../../../common/interactive/CustomSelect'

import classes from './LiabilityItem.module.css'

const DriverInfo = ({data, apiCase}) => {
    const dispatch = useDispatch()
    let liabilityData = data
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 
    const requestSequenceRef = useRef(0)
    const statesOptionsData = useMemo(() => stateOptions(), [])

    const updateHandler = async (data) => {

        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                [data.identifier.field] : data.data.value,
            }
        }
        let dispatchBody = {
            folder: 'liabilities',
            item: {
                itemId: liabilityData.id,
                fields: [
                    {
                        field: data.identifier.field,
                        value: data.data.value
                    }
                ]            
            }
        }
       
        if (liabilityData.vehicle_owner_same_as_driver) {

            switch (data.identifier.field) {
                case 'driver_name':
                    reqBody.fields.vehicle_owner_name = data.data.value
                    dispatchBody.item.fields.push({
                        field: 'vehicle_owner_name',
                        value: data.data.value
                    })
                    break;
                case 'driver_address':
                    reqBody.fields.vehicle_owner_address = data.data.value
                    dispatchBody.item.fields.push({
                        field: 'vehicle_owner_address',
                        value: data.data.value
                    })
                    break;
                case 'driver_city':
                    reqBody.fields.vehicle_owner_city = data.data.value
                    dispatchBody.item.fields.push({
                        field: 'vehicle_owner_city',
                        value: data.data.value
                    })
                    break;
                case 'driver_zip':
                    reqBody.fields.vehicle_owner_zip = data.data.value
                    dispatchBody.item.fields.push({
                        field: 'vehicle_owner_zip',
                        value: data.data.value
                    })
                    break;
                case 'driver_state':
                    reqBody.fields.vehicle_owner_state = data.data.value
                    dispatchBody.item.fields.push({
                        field: 'vehicle_owner_state',
                        value: data.data.value
                    })
                    break;
                default:
                    break;
            }
        }

        // Defer optimistic merge so focus can move immediately to the next field.
        setTimeout(() => {
            dispatch(caseActions.modifyActiveCaseMultiple(dispatchBody))
        }, 0)

        const fieldKey = `${reqBody.type}:${reqBody.type_id}:${data.identifier.field}`
        const requestSequence = requestSequenceRef.current + 1
        requestSequenceRef.current = requestSequence

        let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, null, null, {
            staleGuardKey: `${activeCase.case.id}:${fieldKey}`,
            staleGuardSequence: requestSequence,
        })

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        }      
        
    }

    return <div className="flex-container">
        <h5 className={classes.title_width}>Driver Info</h5>
        <div className="flex-container-equal gap-8">                                
            <InputBox label={'Name'} type={'text'} currentValue={data.driver_name} action={updateHandler} identifier={{type: apiCase, field: 'driver_name', type_id: data.id}} maxWidth={180}/>
            <InputBox label={'Address'} type={'text'} currentValue={data.driver_address} action={updateHandler} identifier={{type: apiCase, field: 'driver_address', type_id: data.id}} maxWidth={180}/>
            <div className="flex-container-equal">
                <InputBox label={'City'} type={'text'} currentValue={data.driver_city} action={updateHandler} identifier={{type: apiCase, field: 'driver_city', type_id: data.id}} minWidth={130}/>
                <CustomSelect action={updateHandler} label={'State'} optionsData={statesOptionsData} preSelectedValue={data.driver_state}  identifier={{type: apiCase, field: 'driver_state', type_id: data.id, folder: 'liabilities'}} hasRemove={true}/>
                <InputBox label={'Postcode'} type={'text'} currentValue={data.driver_zip} action={updateHandler} identifier={{type: apiCase, field: 'driver_zip', type_id: data.id}} format={'zip'}/>
            </div>
        </div>
    </div>
}

export default DriverInfo